import { Card, Col, Row } from 'reactstrap';

export const DaysComponent = ({ data }) => {
  return (
    // <Card body>
    <Col
      style={{ borderRadius: '5px' }}
      className={'d-flex flex-column bg-white pt-1 pb-1'}
    >
      <Col md={12} className="mb-2">
        <div
          className="text-center"
          style={{
            color: '#6D6B7B',
            fontSize: 14,
            fontWeight: 600
          }}
        >
          Puntos por Pilar
        </div>
      </Col>

      <Col md="12" className={'d-flex justify-content-center'}>
        <Col md={4}>
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 26
            }}
          >
            {data.emotions || 0}
          </div>
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 10
            }}
          >
            Emociones
          </div>
        </Col>

        <Col md={4}>
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 26
            }}
          >
            {data.relations || 0}
          </div>
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 10
            }}
          >
            Relaciones
          </div>
        </Col>
        <Col md={4}>
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 26
            }}
          >
            {data.transformation || 0}
          </div>
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 10
            }}
          >
            Transformacion
          </div>
        </Col>
      </Col>

      <Col md="12" className={'d-flex justify-content-center'}>
        <Col className="mt-2" md={6}>
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 26
            }}
          >
            {data.purpose || 0}
          </div>
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 10
            }}
          >
            Sentido de la vida
          </div>
        </Col>

        <Col className="mt-2" md={6}>
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 26
            }}
          >
            {data.selfEsteem || 0}
          </div>
          <div
            className="text-center"
            style={{
              color: '#6D6B7B',
              fontSize: 10
            }}
          >
            Amor Propio
          </div>
        </Col>
      </Col>

      {/* <Col md={2} /> */}
    </Col>
    // </Card>
  );
};
